// extracted by mini-css-extract-plugin
module.exports = {"root":"_5a30af","carouselContainer":"_28199d","articlesRoot":"_1ee592","buttonsContainer":"_57c3eb"};